import { useCallback, useLayoutEffect, useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";

import { MOBILE_APP_TO_WEB_APP_ROUTE_MAP } from "../utils/constants";

const MOBILE_APP_OPENING_ATTEMPT_DURATION = 2000;

function useDeepLink() {
  const navigate = useNavigate();
  const { pathname, search } = useLocation();
  const [isTryingToOpenMobileApp, setIsTryingToOpenMobileApp] = useState(true);

  const mobileAppRoute = MOBILE_APP_TO_WEB_APP_ROUTE_MAP[pathname];

  const openApp = useCallback(() => {
    if (!mobileAppRoute) {
      setIsTryingToOpenMobileApp(false);
      return;
    }

    const timeoutId = setTimeout(() => {
      navigate(`${pathname}${search}`);
      setIsTryingToOpenMobileApp(false);
    }, MOBILE_APP_OPENING_ATTEMPT_DURATION);

    const handleVisibilityChange = () => {
      if (document.visibilityState === "hidden") {
        clearTimeout(timeoutId);
        document.removeEventListener(
          "visibilitychange",
          handleVisibilityChange
        );
      }
    };

    document.addEventListener("visibilitychange", handleVisibilityChange);

    window.location.href = mobileAppRoute;
  }, [mobileAppRoute, navigate, pathname, search]);

  useLayoutEffect(() => {
    openApp();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return { isTryingToOpenMobileApp };
}

export default useDeepLink;
